import { EventrDate, IField } from '@eventr/common'
import { TimezoneDropdown, useIpInfo } from '@eventr/common-storybook'
import { FC, useEffect, useState } from 'react'
import i18n from '../../../i18n/i18next'
import { useEditSectionContext } from '../editSectionProvider'

interface ITimezoneSelectorFieldProps {
    field: IField
    _id?: string
}

export const TimezoneSelector: FC<ITimezoneSelectorFieldProps> = ({
    field,
    _id,
}) => {
    const usersTimezone = useIpInfo((s) => s.ipInfo.timeZones)

    const { getValue, updateValues } = useEditSectionContext()

    const [selectedTimeZone, setSelectedTimeZone] = useState<string>(
        getValue(field, _id) && getValue(field, _id).timeZone
            ? getValue(field, _id).timeZone
            : usersTimezone[0]
    )

    useEffect(() => {
        const tmpValue = structuredClone(getValue(field, _id))
        if (tmpValue && tmpValue.timeZone) {
            if (tmpValue.timeZone !== selectedTimeZone) {
                setSelectedTimeZone(tmpValue.timeZone)
            }
        }
    }, [field, _id, getValue])

    useEffect(() => {
        let valueCopy = structuredClone(getValue(field, _id))
        if (valueCopy) {
            if (valueCopy.timeZone === selectedTimeZone) {
                return
            }
            valueCopy['timeZone'] = selectedTimeZone
        } else {
            valueCopy = {
                timeZone: selectedTimeZone,
            }
        }
        updateValues({
            field: field,
            _id: _id,
            value: valueCopy,
        })
    }, [selectedTimeZone])

    const selectedDateTimeString = () => {
        const newEventrDate = new EventrDate()
        newEventrDate.setTimezone(selectedTimeZone)
        return newEventrDate.dateTimeString
    }

    return (
        <TimezoneDropdown
            id={'timezoneDropdown'}
            fieldLabel={i18n.t(`edit-itinerary.fields.${field.id}`) + ' *'}
            placeholder=""
            defaultTZText=""
            withOutItinDefaultOption
            selectedDateTimeString={selectedDateTimeString()}
            onChange={(item) => {
                setSelectedTimeZone(item.obj.timezone)
            }}
        />
    )
}
